import React, { Fragment } from 'react'

/* Images */
import firstImage from '../images/plasticProducts/IT1000.jpg';
import secondImage from '../images/plasticProducts/kasi.jpg';
import thirdImage from '../images/plasticProducts/IT220.jpg';
import fourthImage from '../images/plasticProducts/HPIM0920_cr.jpg';

/* Components */
import InfoBlock from "../presentational/InfoBlock";

const Plastics = () => {
    return (
        <Fragment>
            <InfoBlock>
                <div style={{ textAlign: 'center' }}>
                    <img src={firstImage} alt={""} width={500} style={{ marginBottom: 20 }} />

                    <p style={{ marginBottom: 20 }}>
                        Изпитания на шприцформи на машини Италтех, Енгел, Куази и HQT със сила на притискане между 1200 и 150t. Производство на пилотни серии по желание на клиента.
                    </p>

                    <img src={secondImage} alt={""} style={{ marginBottom: 20 }} />

                    <p style={{ marginBottom: 20 }}>
                        Производство на пластмасови изделия за вътрешния пазар, като каси, касети, домакински изделия, диализатори, технически части със собствени шприцформи и инструменти на клиента.
                    </p>

                    <div className="image-group" style={{ marginBottom: 20 }}>
                        <img src={thirdImage} alt={""} width={500} />

                        <img src={fourthImage} alt={""} width={500} />
                    </div>

                    <p> Тази машина е закупена с финансовото съдействие на програма PHARE на ЕС. </p>
                </div>
            </InfoBlock>
        </Fragment>
    )
}

export default Plastics


// WEBPACK FOOTER //
// ./src/containers/Plastics.js